var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",attrs:{"type":_vm.buttonType || 'button',"disabled":_vm.spinning},on:{"click":function($event){return _vm.propagate($event)}}},[(_vm.spinning)?_c('span',{staticClass:"spinner-border spinner-border-sm mr-2",attrs:{"role":"status","aria-hidden":"true"}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }